import { syncPersistedData } from './actions';

export const DATA_SETS_STORAGE_KEY = 'stored-datasets/v2';
export const SYNC_IN_PROGRESS_KEY = 'sync-in-progress-in-the-session-id-equal-to';

export const DATA_TESTS_PERSIST_TRIGGER_ACTIONS = [
  syncPersistedData().type,
];
